import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function CategoryGrid() {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            探索视频分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            六大分类，全方位覆盖鲍鱼产业链的每一个环节
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => {
            const count = articles.filter((a) => a.category === cat.slug).length;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={handleClick}
                className="group relative overflow-hidden rounded-xl aspect-[4/5] cursor-pointer"
              >
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute inset-0 flex flex-col items-center justify-end p-3 md:p-4 text-center">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-500/90 mb-2 md:mb-3">
                    <i className={`${cat.icon} text-lg md:text-xl text-background-50`}></i>
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-background-50 mb-1">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-background-50/70">
                    {count} 个视频
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}